export default "__VITE_ASSET__a5cc6b09__"